import { ExpensesTableModule } from '@repo/claims-tables/ExpensesTableModule'
import { OvertimeTableModule } from '@repo/claims-tables/OvertimeTableModule'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useNavigate } from 'react-router-dom'
import MUIBox from '@mui/material/Box'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'

type TabValue = 'expenses' | 'overtime'

export const ExpensesOvertimeModule = ({ isSubmissionVersion, selectedTab }: ExpensesOvertimesModuleProps) => {
  const { pageTitleBlockIsVisible } = useGlobalSettingsStore()
  const { enableExpenses, enableOvertime } = useLookupsStore()
  const { allowedActions } = useMenuItemsStore()
  const { submitExpenseClaims, submitOvertimeClaims, processExpenseClaims, processOvertimeClaims } = allowedActions
  const submitExpenseClaimsAllowed = submitExpenseClaims?.allowed || false
  const processExpenseClaimsAllowed = processExpenseClaims?.allowed || false
  const submitOvertimeClaimsAllowed = submitOvertimeClaims?.allowed || false
  const processOvertimeClaimsAllowed = processOvertimeClaims?.allowed || false

  const featuresEnabled = enableExpenses === true && enableOvertime === true

  const showSubmitTabs = featuresEnabled && submitExpenseClaimsAllowed === true && submitOvertimeClaimsAllowed === true
  const showProcessTabs = featuresEnabled && processExpenseClaimsAllowed === true && processOvertimeClaimsAllowed === true

  const showTabs = isSubmissionVersion ? showSubmitTabs : showProcessTabs

  const navigate = useNavigate()

  const changeTab = (value: TabValue) => {
    if (isSubmissionVersion) {
      if (value === 'expenses') {
        navigate(`/my-account/expense-claims`)
      } else {
        navigate(`/my-account/overtime-claims`)
      }
    } else {
      if (value === 'expenses') {
        navigate(`/accounts/employee-claims/expense-claims`)
      } else {
        navigate(`/accounts/employee-claims/overtime-claims`)
      }
    }
  }

  return (
    <MUIBox sx={{ mb: 8, mt: pageTitleBlockIsVisible ? '0rem' : '9rem', borderBottom: 0 }}>
      {showTabs && (
        <MUITabs
          value={selectedTab}
          onChange={(_, value: TabValue) => changeTab(value)}
          sx={{ mb: 0, ml: 18, borderBottom: 0, minHeight: '3rem', position: 'relative', zIndex: 1 }}
        >
          <MUITab value="expenses" label={'Expense claims'} />
          <MUITab value="overtime" label={'Overtime claims'} />
        </MUITabs>
      )}
      {selectedTab === 'expenses' && enableExpenses && (
        <ExpensesTableModule isSubmissionVersion={isSubmissionVersion} />
      )}
      {selectedTab === 'overtime' && enableOvertime && (
        <OvertimeTableModule isSubmissionVersion={isSubmissionVersion} />
      )}
    </MUIBox>
  )
}

type ExpensesOvertimesModuleProps = {
  isSubmissionVersion?: boolean
  selectedTab: TabValue
}
